import { Button, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';

import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import { useEffect } from 'react';
import { checkValidForm } from './Step1';
import BtnSave from './BtnSave';

const Step3 = (props) => {
    const { t } = useTranslation();

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep3(true);
            })
            .catch(() => props.setStep3(false));
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.dataSubjectRightAndSecure) {
            onValuesChange(null, props.previewData?.dataSubjectRightAndSecure);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'rightToWithdrawConsentTh',
            'rightOfAccessTh',
            'rightOfDataPortabilityTh',
            'rightToObjectTh',
            'rightToRestrictProcessingTh',
            'rightToErasureTh',
            'rightToRectificationTh',
            'securityMeasureTh',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep3(check);
    };

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('policy.des3')}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="dataSubjectRightAndSecure"
                layout="vertical"
                form={props?.form}
            >
                <div>
                    <span className="text-[21px] font-bold">
                        {t('policy.dec3_1')}
                    </span>
                </div>
                <Form.Item
                    className="mt-4"
                    name="rightToWithdrawConsentTh"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToWithdrawConsentTh')}
                                </span>
                            </div>
                        </div>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decTHPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="rightToWithdrawConsentEn"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToWithdrawConsentEn')}
                                </span>
                            </div>
                        </div>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decENPl')}
                    />
                </Form.Item>
                <Divider dashed className="border-t-2" />
                <Form.Item
                    className="mt-4"
                    name="rightOfAccessTh"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightOfAccessTh')}
                                </span>
                            </div>
                        </div>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decTHPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="rightOfAccessEn"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightOfAccessEn')}
                                </span>
                            </div>
                        </div>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decENPl')}
                    />
                </Form.Item>
                <Divider dashed className="border-t-2" />
                <Form.Item
                    className="mt-4"
                    name="rightOfDataPortabilityTh"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightOfDataPortabilityTh')}
                                </span>
                            </div>
                        </div>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decTHPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="rightOfDataPortabilityEn"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightOfDataPortabilityEn')}
                                </span>
                            </div>
                        </div>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decENPl')}
                    />
                </Form.Item>
                <Divider dashed className="border-t-2" />
                <Form.Item
                    className="mt-4"
                    name="rightToObjectTh"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToObjectTh')}
                                </span>
                            </div>
                        </div>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decTHPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="rightToObjectEn"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToObjectEn')}
                                </span>
                            </div>
                        </div>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decENPl')}
                    />
                </Form.Item>
                <Divider dashed className="border-t-2" />
                <Form.Item
                    className="mt-4"
                    name="rightToRestrictProcessingTh"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToRestrictProcessingTh')}
                                </span>
                            </div>
                        </div>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decTHPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="rightToRestrictProcessingEn"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToRestrictProcessingEn')}
                                </span>
                            </div>
                        </div>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decENPl')}
                    />
                </Form.Item>
                <Divider dashed className="border-t-2" />
                <Form.Item
                    className="mt-4"
                    name="rightToErasureTh"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToErasureTh')}
                                </span>
                            </div>
                        </div>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decTHPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="rightToErasureEn"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToErasureEn')}
                                </span>
                            </div>
                        </div>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decENPl')}
                    />
                </Form.Item>
                <Divider dashed className="border-t-2" />
                <Form.Item
                    className="mt-4"
                    name="rightToRectificationTh"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToRectificationTh')}
                                </span>
                            </div>
                        </div>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decTHPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="rightToRectificationEn"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToRectificationEn')}
                                </span>
                            </div>
                        </div>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decENPl')}
                    />
                </Form.Item>
                <Divider dashed className="border-t-2" />
                <Form.Item
                    className="mt-4"
                    name="rightToComplaintTh"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToComplaintTh')}
                                </span>
                            </div>
                        </div>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decTHPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="rightToComplaintEn"
                    label={
                        <div className="flex space-x-2 pl-2">
                            <div className="w-1 -mt-[1px]">{Dot}</div>
                            <div>
                                <span className="text-[16px] font-bold">
                                    {t('policy.rightToComplaintEn')}
                                </span>
                            </div>
                        </div>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decENPl')}
                    />
                </Form.Item>
                <Divider />
                <Form.Item
                    className="mt-4"
                    name="securityMeasureTh"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.securityMeasureTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decTHPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name="securityMeasureEn"
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.securityMeasureEn')}
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.decENPl')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="ml-4"
                            onClick={onNextStep}
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave saveDraft={props.saveDraft} />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step3;

const Dot = (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50" />
    </svg>
);
